import { FC, useMemo } from 'react';
import Container from '~/components/Container';
import { Identifiers } from '~/constants/enum';
import useCmsBlocks from '~/hooks/useCmsBlocks';
import styles from './Brand.module.scss';
import BrandSkeleton from './Brand.skeleton';

interface BrandProps {}

const Brand: FC<BrandProps> = () => {
    const { cmsBlocks, loading } = useCmsBlocks([Identifiers.HomeBrand]);

    const cmsContent = useMemo(() => {
        const block = cmsBlocks[Identifiers.HomeBrand as unknown as keyof typeof cmsBlocks];
        if (typeof block === 'object' && block !== null && 'content' in block) {
            return block?.content;
        }
        return null;
    }, [cmsBlocks]);

    const newHtml = (html: string) => {
        ['first_brand', 'brand_item'].forEach((item) => {
            html = html.replaceAll(item, styles[item]);
        });
        return html;
    };

    if (loading) return <BrandSkeleton />;

    if (!cmsContent && !loading) return null;
    return (
        <Container rootClassName={styles.brand_wrapper}>
            <div className={styles.brand} dangerouslySetInnerHTML={{ __html: newHtml(cmsContent) }} />
        </Container>
    );
};

export default Brand;
